import _ from 'lodash';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';

export default {
  props: {
    offer_config: {
      type: Object,
      default: null,
    },
  },
  components: {
    'box-widget': BoxWidget,
  },
  computed: {
    fields() {
      return [
        { name: 'title', translate: false, isTime: false },
        { name: 'end_date_time', translate: false, isTime: true },
        { name: 'details', translate: false, isTime: false },
        { name: 'code_type', translate: true, isTime: false },
        { name: 'offer_url', translate: false, isTime: false },
        { name: 'code', translate: false, isTime: false },
        { name: 't_c', translate: false, isTime: false },
        { name: 'redeem', translate: true, isTime: false },
        { name: 'same_offer', translate: false, isTime: false },
      ];
    },
  },
  methods: {
    formatFieldValue(value, config) {
      if (_.isEmpty(value) && !_.isBoolean(value)) {
        return '-';
      }
      if (config.isTime) {
        return this.$t('fn.datetime', { timestamp: value });
      } else if (config.translate) {
        return this.$t(`pos.creative.offer_brief.${config.name}_options.${value}`);
      }
      return value;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/offer-brief/OfferBrief.js